<template>
  <b-modal
      v-model="modalVisible"
      title="Historial de registros"
      size="xl"
      hide-footer
      @hidden="$emit('update:showLogsModal', false)"
  >
    <div style="overflow-x:auto; max-height:400px;">
      <table class="table table-bordered table-hover">
        <thead>
        <tr>
          <th>Usuario</th>
          <th>Info</th>
          <th>Fecha/Hora</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(log, index) in paginatedLogs" :key="index">
          <td>{{ log.user.name }}</td>
          <td style="word-wrap:break-word; max-width:200px;">{{ log.info }}</td>
          <td>{{ formatDateTime(log.created_at) }}</td>
        </tr>
        <tr v-if="!logs.length">
          <td colspan="3" class="text-center">No hay registros</td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <div class="d-flex justify-content-between" v-if="totalPages > 1">
      <div class="d-flex">
        <span class="align-content-center">Página {{ currentPage }} de {{ totalPages }}</span>
      </div>
      <div>
        <button
            :disabled="currentPage === 1"
            @click="previousPage"
            class="btn btn-outline-primary mr-1 cursor-pointer btn btn-outline-primary"
        >
          Anterior
        </button>
        <button
            :disabled="currentPage === totalPages"
            @click="nextPage"
            class="btn btn-outline-primary cursor-pointer btn btn-outline-primary"
        >
          Siguiente
        </button>
      </div>
    </div>

  </b-modal>
</template>

<script>
import { BModal } from "bootstrap-vue"
import "vue2-dropzone/dist/vue2Dropzone.min.css"
export default {
  props: {
    showLogsModal: {
      type: Boolean,
      required: true
    },
    logs: {
      type: Array,
      required: true
    },
    perPage: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      currentPage: 1
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.logs.length / this.perPage)
    },
    paginatedLogs() {
      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage
      return this.logs.slice(start, end)
    },
    modalVisible: {
      get() {
        return this.showLogsModal
      },
      set(value) {
        this.$emit("update:showLogsModal", value)
      }
    }
  },
  methods: {
    formatDateTime(datetime) {
      const date = new Date(datetime)
      const formattedDate = date.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      })
      const formattedTime = date.toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      })
      return `${formattedDate} ${formattedTime}`
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    }
  }
}
</script>

<style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
  @import "@core/scss/vue/libs/vue-flatpicker.scss";

  [dir] .modal .modal-header .close {
    box-shadow: none;
    transform: unset;
    background: none;
  }

  .v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
  }

  [data-popper-placement="top"] {
    border-radius: 4px 4px 0 0;
    border-top-style: solid;
    border-bottom-style: none;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
  }

  .row_shared {
    background-color: #cbe7ff !important;
  }
</style>
